import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function IsLocalIpHttpOnly(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const ipRegex = /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;

    const value: string = control.value;

    if (!value) {
      return { invalidLocalIpForHttp: true };
    }

    const parts = value.split('.').map(Number);

    if (!ipRegex.test(value) || parts.length !== 4 || parts.some(p => isNaN(p) || p < 0 || p > 255)) {
      return { invalidLocalIpForHttp: true };
    }

    const [a, b] = parts;

    const isPrivate = a === 10 || (a === 172 && b >= 16 && b <= 31) || (a === 192 && b === 168) || (a === 127);

    return isPrivate ? null : { invalidLocalIpForHttp: true };
  };
}
